import { InputNumber } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { requiredInputNumberRules } from '../../../../../../../../../../constants/forms/validation/rules'

interface FloodsProps {}

const Floods: FC<FloodsProps> = () => {
    const name = 'floods'

    return (
        <Form.Item name={name} label={'Ручьи'} rules={requiredInputNumberRules}>
            <InputNumber />
        </Form.Item>
    )
}

export default Floods
